import React from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import { pick } from "lodash";
import Panel from "common/components/Panel";
import { transformApiError } from "common/api/errors";
import client from "common/admin/client";
import ServiceForm from "./Form";
import { withUrlResource } from "common/utils";
import { useTranslation } from "react-i18next";
import { localStorage } from "common/storage";

const handleSubmit = (buildingId) => async (values, form) => {
  const body = pick(
    values,
    "category",
    "title",
    "body",
    "location",
    "hours",
    "image",
  );
  const { setSubmitting, setErrors, setStatus, resetForm } = form;

  try {
    const formData = new window.FormData();

    // Append the picked values to FormData
    Object.keys(body).forEach((key) => {
      // Append the image file directly to FormData
      if (key === "image" && body[key] && body[key] instanceof File) {
        formData.append("media_metadata", body[key]); // Ensure image is properly appended
      } else {
        formData.append(key, body[key]); // Append the other fields
      }
    });

    await client.post(`buildings/${buildingId}/services`, { body: formData });
    resetForm();
    setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);
    if (apiError.empty()) {
      setErrors({ http: error.message });
    } else {
      setErrors(apiError.object());
    }
  }
  setSubmitting(false);
};

const CreateBuilding = ({ classes, urlResource }) => {
  const { t } = useTranslation();
  const ishilo = localStorage.getItem("HILO") === "true";

  return (
    <Panel title={t("services_create.title")}>
      <ServiceForm
        handleSubmit={handleSubmit(urlResource.id)}
        initialValues={{
          category: "",
          title: "",
          body: "",
          location: "",
          hours: "",
          ishilo,
        }}
      />
    </Panel>
  );
};

const styles = (theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
});

CreateBuilding.propTypes = {
  classes: PropTypes.object.isRequired,
  urlResource: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};

const enhanced = compose(withStyles(styles), withUrlResource);

export default enhanced(CreateBuilding);
